// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2218":"dd6a8008b722de98","2827":"bf4d3a1d02770315","3875":"75b1a026cb9ea7ed","4539":"0f3a26c2f8e31d0a","6456":"9675a6edc0af9a00"}[chunkId] + ".css";
};